var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`component__sort-button ${_vm.value}`},[_c('i',{staticClass:"sort-caret ascending",on:{"click":function($event){return _vm.change('asc')}}}),_c('i',{staticClass:"sort-caret descending",on:{"click":function($event){return _vm.change('desc')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }